import { render, staticRenderFns } from "./StatementDetails.vue?vue&type=template&id=6bcbe6eb&"
import script from "./StatementDetails.vue?vue&type=script&lang=js&"
export * from "./StatementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports